// 跨周命中统计工具（TagPage / SearchPage 共用）
//
// 两页原先各自逐行实现了几乎相同的「按周分组 → 跨周合并去重 → 算各周命中数 / 全部时间命中」。
// 这里把这段纯逻辑抽出来，调用方只传入「按周分组的命中映射」与去重键，返回：
//   - filteredDateRanges：含命中的周列表（不含 ignore 中的哨兵，如全部时间）
//   - rangeCounts：各周命中数 { "YYYY-MM-DD - YYYY-MM-DD": n }
//   - allTimeList / allTimeCount：跨周去重合并后的「全部时间」命中
//
// 设计取舍：只收敛「纯统计」部分；各页「按标签 / 按关键词筛选」与「选中周回退」等差异逻辑
// 仍留在各自页面（差异小且语义不同），避免把页面特有的筛选条件也塞进通用函数。

// 去重键默认取 url 或 name（与历史实现一致：规避同一产品跨周重复计数）
const DEFAULT_DEDUPE_KEY = (item) => item && (item.url || item.name);

export function buildRangeStats(
  itemsByRange,
  { dedupeKey = DEFAULT_DEDUPE_KEY, ignore = [] } = {}
) {
  const byRange = {}; // 含命中的周 → 产品数组
  const seen = new Set();
  const allTime = [];

  for (const range of Object.keys(itemsByRange || {})) {
    if (ignore.includes(range)) continue; // 跳过全部时间哨兵等不参与周 tab 的键
    const items = itemsByRange[range];
    if (!items || items.length === 0) continue;

    byRange[range] = items;
    for (const item of items) {
      const key = dedupeKey(item);
      // 不跳过 key 为 null/undefined 的项：与历史实现一致（Set 可容纳 null 键做去重），
      // 避免「缺 url/name 的产品」被整体漏计
      if (!seen.has(key)) {
        seen.add(key);
        allTime.push(item);
      }
    }
  }

  const ranges = Object.keys(byRange);
  const rangeCounts = {};
  for (const r of ranges) rangeCounts[r] = byRange[r].length;

  return {
    filteredDateRanges: ranges,
    rangeCounts,
    allTimeList: allTime,
    allTimeCount: allTime.length,
  };
}
